import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "AppointmentPayment.AppointmentPaymentAddDialog.title",
    defaultMessage: "Add Payment",
  },
  btnSubmit: {
    id: "AppointmentPayment.AppointmentPaymentAddDialog.btnSubmit",
    defaultMessage: "Confirm payment",
  },
  btnCancel: {
    id: "AppointmentPayment.AppointmentPaymentAddDialog.btnCancel",
    defaultMessage: "Cancel",
  },
});

export default messages;
